var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('voucher-form',{attrs:{"post":_vm.currentVoucher,"loading":_vm.loading},on:{"submit":_vm.updateVoucher}}),_c('voucher-orders',{attrs:{"title":"Orders"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }